import { AxiosInstance, AxiosResponse } from 'axios';
import { AnnotationCreateDto } from './inputs/annotation-create.input';
import { AnnotationUpdateDto } from './inputs/annotation-update.input';
import { AnnotationDeleteResponse } from './responses/annotation-delete.response';
import { AnnotationEntryResponse } from './responses/annotation-entry.response';

export class AnnotationsModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async createOne(dto: AnnotationCreateDto): Promise<AxiosResponse<AnnotationEntryResponse>> {
    return await this.client.post('/annotations/', dto);
  }

  async updateOne(
    id: string,
    dto: AnnotationUpdateDto,
  ): Promise<AxiosResponse<AnnotationEntryResponse>> {
    return await this.client.put(`/annotations/${id}`, dto);
  }

  async getOne(id: string): Promise<AxiosResponse<AnnotationEntryResponse>> {
    return await this.client.get(`/annotations/${id}`);
  }

  async getMany(): Promise<AxiosResponse<AnnotationEntryResponse[]>> {
    return await this.client.get(`/annotations/`);
  }

  async deleteOne(id: string): Promise<AxiosResponse<AnnotationDeleteResponse>> {
    return await this.client.delete(`/annotations/${id}`);
  }
}
